import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import {
    ManagementFiltersValues,
    ManagementFormValues,
} from "../domain/models/Management";

export const managementFiltersFields: Fields<ManagementFiltersValues> = {
    fullName: {
        min: 2,
        max: 90,
        placeholderKey: "console.management.table.fullName",
        type: "text",
        optional: true,
        initial: "",
    },
    position: {
        min: 2,
        max: 90,
        placeholderKey: "console.management.table.position",
        type: "text",
        optional: true,
        initial: "",
    },
    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.management.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
    isActive: {
        type: "checkbox",
        placeholderKey: "console.management.table.isActive",
        optional: true,
        initial: true,
    },
};

export const managementFields: Fields<ManagementFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    translations: {
        objectArray: {
            fullName: {
                min: 2,
                max: 90,
                placeholderKey: "console.management.table.fullName",
                type: "text",
                optional: false,
                initial: "",
            },
            position: {
                min: 2,
                max: 90,
                placeholderKey: "console.management.table.position",
                type: "text",
                optional: false,
                initial: "",
            },
            // Fields that are set programmatically (not by the user, from entity)
            managementId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
    isActive: {
        type: "checkbox",
        placeholderKey: "console.management.table.isActive",
        optional: false,
        initial: true,
    },
};

export const managementFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, managementFiltersFields);
};

export const managementSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, managementFields);
};
